import { combineReducers } from '@reduxjs/toolkit'; // Import from @reduxjs/toolkit
import appReducer from './appReducer';
import selectedItemsSlice from '../slices/selectedItemsSlice'; // Use the slice name directly

const rootReducer = combineReducers({
  app: appReducer,
  selectedItems: selectedItemsSlice.reducer, // Access the .reducer property of the slice
});

export default rootReducer;